<script setup lang="ts">
const t2 = useT2({})

const { myLink } = useLinks()

useDelayInit(1000, () => navigateTo(myLink('info-faq', {})))
</script>

<template>
  <AppMenu :title="t2('Customer Care')">
    <UiLoadingBox :repeat="9" mb="_mb1" height="_h60" />
  </AppMenu>
</template>
